"use client";
import React from "react";
import "./SpecialPrices.scss";
import Image from "next/image";
import lumber from "../../../../public/assets/Home/Categories/Lumber.webp";
import { useMediaQuery } from "@mui/material";
import Link from "next/link";
import { motion } from "framer-motion";
import { fadeUp, slideFromRight, defaultViewport } from "@/utils/animations";

const SpecialPrices = () => {
  const isMobile = useMediaQuery("(max-width:1023px)");

  return (
    <div className="home-special-prices-wrapper baseContainer">
      <div className="maxWidth">
      <motion.div
        className="left"
        variants={fadeUp}
        initial="hidden"
        whileInView="visible"
        viewport={defaultViewport}
      >
        <p className="section-main-header black">Get Exclusive Benefits</p>
        <p className="text-medium-24 weight-500 grey-700">
          Apply for a contractor or credit account with Amherst Supply to access
          special pricing, extended payment terms, and personalized service.
        </p>

        {!isMobile && (
          <Link href="/account-applications">
            <button className="main-btn red">More Details</button>
          </Link>
        )}
      </motion.div>

      <motion.div
        className="right"
        variants={slideFromRight}
        initial="hidden"
        whileInView="visible"
        viewport={defaultViewport}
      >
        <p className="text-medium-24 blue-500 weight-600">special prices for</p>
        <p className="section-main-header bg-red">Contractors</p>

        <Image src={lumber} alt="Amherst Supply" />
      </motion.div>

      {isMobile && (
        <Link href="/account-applications">
          <button className="main-btn red">More Details</button>
        </Link>
      )}
      </div>
    </div>
  );
};

export default SpecialPrices;
